import { render, staticRenderFns } from "./vipCharge.vue?vue&type=template&id=30cb6f74&scoped=true"
import script from "./vipCharge.vue?vue&type=script&lang=js"
export * from "./vipCharge.vue?vue&type=script&lang=js"
import style0 from "./vipCharge.vue?vue&type=style&index=0&id=30cb6f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cb6f74",
  null
  
)

export default component.exports